import { AutogenLayoutTractorList } from "./autogen/AutogenLayoutTractorList";

export class TractorList extends AutogenLayoutTractorList {

    override onLoad() {
        this.mainDataSource.search({service_status: "A"});
    }
}
